module.exports = {
          srcSet: __webpack_public_path__ + "8e863eb0b5f190ac30302bb4068cfcc0-160.png"+" 160w",
          images:[ {path: __webpack_public_path__ + "8e863eb0b5f190ac30302bb4068cfcc0-160.png",width: 160,height: 30}],
          src: __webpack_public_path__ + "8e863eb0b5f190ac30302bb4068cfcc0-160.png",
          toString:function(){return __webpack_public_path__ + "8e863eb0b5f190ac30302bb4068cfcc0-160.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAPUlEQVR4nC3HoRGAIAAAwN+FAawOQLS4B9GDoxENFAIreM7BZBa/PVw40JGw/98QEHHCjYyCFxMPGioG1gcrMwjIKqrNlwAAAABJRU5ErkJggg==",
          width: 160,
          height: 30
        }